module.exports = __webpack_public_path__ + "img/hit1.53de5629.svg";